package pt.at.oss.kotlin.manual.schema.common.contactname

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_FIRST_NAME_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_FREE_TEXT_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_GENERAL_SUFFIX_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_LAST_NAME_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_LAST_NAME_PREFIX_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_MAIDEN_NAME_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.CONTACT_NAME_PRECEDING_TITLE_MAX_LEN
import pt.at.oss.kotlin.manual.schema.common.contactname.generationidentifiers.GenerationIdentifiersEntrySchema
import pt.at.oss.kotlin.manual.schema.common.contactname.middlenames.MiddleNamesEntrySchema
import pt.at.oss.kotlin.manual.schema.common.contactname.suffixes.SuffixesEntrySchema
import pt.at.oss.kotlin.manual.schema.common.contactname.titles.TitlesEntrySchema
import pt.at.oss.kotlin.manual.storage.common.contactname.ContactName
import pt.at.oss.kotlin.manual.storage.common.contactname.generationidentifiers.GenerationIdentifiersEntry
import pt.at.oss.kotlin.manual.storage.common.contactname.middlenames.MiddleNamesEntry
import pt.at.oss.kotlin.manual.storage.common.contactname.suffixes.SuffixesEntry
import pt.at.oss.kotlin.manual.storage.common.contactname.titles.TitlesEntry
import pt.lightweightform.kotlin.schema.ListSchema
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * ContactNameSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class ContactNameSchema : RecordSchema<ContactName>(name = "contactName") {

    val typeSchema: StringSchema = StringSchema(name = "type", isRequired = true)
    val precedingTitleSchema: StringSchema = StringSchema(name = "precedingTitle", maxLength = CONTACT_NAME_PRECEDING_TITLE_MAX_LEN)
    val firstNameSchema: StringSchema = StringSchema(name = "firstName", maxLength = CONTACT_NAME_FIRST_NAME_MAX_LEN)
    val lastNamePrefixSchema: StringSchema = StringSchema(name = "lastNamePrefix", maxLength = CONTACT_NAME_LAST_NAME_PREFIX_MAX_LEN)
    val lastNameSchema: StringSchema = StringSchema(name = "lastName", maxLength = CONTACT_NAME_LAST_NAME_MAX_LEN)
    val generalSuffixSchema: StringSchema = StringSchema(name = "generalSuffix", maxLength = CONTACT_NAME_GENERAL_SUFFIX_MAX_LEN)
    val maidenNameSchema: StringSchema = StringSchema(name = "maidenName", maxLength = CONTACT_NAME_MAIDEN_NAME_MAX_LEN)
    var titlesSchema: ListSchema<TitlesEntrySchema, TitlesEntry> =
        ListSchema(
            name = "titles",
            childRecordSchema = TitlesEntrySchema()
        )
    var middleNamesSchema: ListSchema<MiddleNamesEntrySchema, MiddleNamesEntry> =
        ListSchema(
            name = "middleNames",
            childRecordSchema = MiddleNamesEntrySchema()
        )
    var generationIdentifiersSchema: ListSchema<GenerationIdentifiersEntrySchema, GenerationIdentifiersEntry> =
        ListSchema(
            name = "generationIdentifiers",
            childRecordSchema = GenerationIdentifiersEntrySchema()
        )
    var suffixesSchema: ListSchema<SuffixesEntrySchema, SuffixesEntry> =
        ListSchema(
            name = "suffixes",
            childRecordSchema = SuffixesEntrySchema()
        )
    val freeTextSchema: StringSchema = StringSchema(name = "freeText", maxLength = CONTACT_NAME_FREE_TEXT_MAX_LEN)

    override fun isValid(value: ContactName?): Boolean {
        return value == null || (
            typeSchema.isValid(value.type) &&
                precedingTitleSchema.isValid(value.precedingTitle) &&
                firstNameSchema.isValid(value.firstName) &&
                lastNamePrefixSchema.isValid(value.lastNamePrefix) &&
                lastNameSchema.isValid(value.lastName) &&
                generalSuffixSchema.isValid(value.generalSuffix) &&
                maidenNameSchema.isValid(value.maidenName) &&
                titlesSchema.isValid(value.titles) &&
                middleNamesSchema.isValid(value.middleNames) &&
                generationIdentifiersSchema.isValid(value.generationIdentifiers) &&
                suffixesSchema.isValid(value.suffixes) &&
                freeTextSchema.isValid(value.freeText)
            )
    }

    override fun validate(value: ContactName?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(typeSchema.validate(value.type, appendToPath(path, "type")))
        validator.addErrors(precedingTitleSchema.validate(value.precedingTitle, appendToPath(path, "precedingTitle")))
        validator.addErrors(firstNameSchema.validate(value.firstName, appendToPath(path, "firstName")))
        validator.addErrors(lastNamePrefixSchema.validate(value.lastNamePrefix, appendToPath(path, "lastNamePrefix")))
        validator.addErrors(lastNameSchema.validate(value.lastName, appendToPath(path, "lastName")))
        validator.addErrors(generalSuffixSchema.validate(value.generalSuffix, appendToPath(path, "generalSuffix")))
        validator.addErrors(maidenNameSchema.validate(value.maidenName, appendToPath(path, "maidenName")))
        validator.addErrors(titlesSchema.validate(value.titles, appendToPath(path, "titles")))
        validator.addErrors(middleNamesSchema.validate(value.middleNames, appendToPath(path, "middleNames")))
        validator.addErrors(generationIdentifiersSchema.validate(value.generationIdentifiers, appendToPath(path, "generationIdentifiers")))
        validator.addErrors(suffixesSchema.validate(value.suffixes, appendToPath(path, "suffixes")))
        validator.addErrors(freeTextSchema.validate(value.freeText, appendToPath(path, "freeText")))
        return validator
    }
}
